let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jsSdY")).then(() => parcelRequire('7R5AD'));